export enum VerifyStatusEnum {
  EXISTING = "Existing",
  UPDATED = "Updated",
  NEW = "New",
  MISSING = "Missing"
}